import { capFirstLetter } from '@b2b/common/filters';
import angular from 'angular';

RedemptionStatusFilter.$inject = [];

/**
 * A coupon created before redemption limits existed has no status, and the coupons API treats it
 * as active (its "active" filter matches both). Show it the same way.
 */
export function redemptionStatus(value?: string | null): string {
  return capFirstLetter(value || 'active');
}

function RedemptionStatusFilter() {
  return redemptionStatus;
}

export const RedemptionStatusFilterModule = angular
  .module('acme.view.application.coupons.list.filter.redemptionStatus', [])
  .filter('redemptionStatus', RedemptionStatusFilter).name;
